import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { DataTableRequest } from '../../models/datatable-request';
import { Observable } from 'rxjs';
import { RegulationList } from '../../models/regulation-list';
import { environment } from 'src/environments/environment';
import { CommonConfig } from '../../constants/common-config';
import { RegulationCategoryList } from '../../models/regulation-category-list';
import { Regulation } from 'src/app/models/regulation';

@Injectable({
  providedIn: 'root',
})
export class RegulationService {
  path = '/regulation';

  constructor(private http: HttpClient) { }

  getCategories(): Observable<RegulationCategoryList> {
    return this.http.get<RegulationCategoryList>(
      `${environment.apiUrl}${this.path}/categories`,
      { ...CommonConfig.HTTP_OPTIONS }
    );
  }

  getList(
    categories: number[],
    payload: DataTableRequest
  ): Observable<RegulationList> {
    const params = new HttpParams()
      .append('searchTerm', payload.searchTerm)
      .append('categories', categories.join(','));

    return this.http.get<RegulationList>(
      `${environment.apiUrl}${this.path}/list/${payload.page}/${payload.dataPerPage}`,
      {
        ...CommonConfig.HTTP_OPTIONS,
        params: params,
      }
    );
  }

  getListAll(payload: DataTableRequest): Observable<RegulationList> {
    const params = new HttpParams()
      .append('searchTerm', payload.searchTerm)

    return this.http.get<RegulationList>(
      `${environment.apiUrl}${this.path}/list/all/${payload.page}/${payload.dataPerPage}`,
      {
        ...CommonConfig.HTTP_OPTIONS,
        params: params,
      }
    );
  }

  upload(regulation: Regulation): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('title', regulation.title);
    formData.append('categoryId', regulation.categoryId);
    if (regulation.id != undefined) {
      formData.append('regulationId', regulation.id);
    }
    if (regulation.file != undefined) {
      formData.append('file', regulation.file);
    }

    const req = new HttpRequest('POST', `${environment.apiUrl}/regulation/upload`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  getDownload(filename: string): Observable<Blob> {
    return this.http.get(environment.apiUrl + "/download/2/" + filename, {
      responseType: 'blob'
    });
  }

  delete(id: string): Observable<any> {
    return this.http.delete(environment.apiUrl + '/regulation/delete/' + id);
  }
}
